import { useState } from 'react'
import { styled } from '@mui/material/styles'
import styledLib from 'styled-components'
import TooltipComponent, { tooltipClasses } from '@mui/material/Tooltip'
import { colors } from '@/styles'

const ChildWrapper = styledLib.span`
  display: flex;
`

const CustomTooltip = styled(
  ({ className, offsetRight, offsetLeft, disableTouchListener, ...props }) => (
    <TooltipComponent
      {...props}
      classes={{ popper: className }}
      offsetRight={offsetRight}
      offsetLeft={offsetLeft}
      disableTouchListener={disableTouchListener}
    />
  )
)(props => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: `${colors.backgroundNeutral}`,
    color: colors.white,
    boxShadow: '0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -2px rgba(0, 0, 0, 0.05)',
    borderRadius: 8,
    maxWidth: 270,
    padding: 12,
    fontSize: 14,
    fontWeight: 700,
    right: props.offsetRight ? props.offsetRight : null,
    left: props.offsetLeft ? props.offsetLeft : null
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: `${colors.backgroundNeutral}`
  }
}))

const Tooltip = ({
  children,
  text,
  placement,
  arrow = true,
  openOnMobilePress = false,
  offsetRight,
  offsetLeft,
  disableTouchListener = false
}) => {
  const [showTooltip, setShowTooltip] = useState(false)
  return (
    <CustomTooltip
      open={showTooltip}
      onOpen={() => setShowTooltip(true)}
      onClose={() => setShowTooltip(false)}
      placement={placement}
      title={text}
      arrow={arrow}
      offsetRight={offsetRight}
      offsetLeft={offsetLeft}
      disableTouchListener={disableTouchListener}
    >
      {openOnMobilePress ? (
        <ChildWrapper onClick={() => setShowTooltip(!showTooltip)}>{children}</ChildWrapper>
      ) : (
        children
      )}
    </CustomTooltip>
  )
}

export default Tooltip
